import { forwardRef } from "react";
import { useId } from "react";
function SvgRawGoogleIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="#fff" clipPath={`url(#RawGoogleIcon_svg__a${toAppend})`}>
        <path d="M15.83 8.18c0-.527-.047-1.027-.127-1.514H8.17v3.007h4.313a3.714 3.714 0 0 1-1.6 2.386v2h2.574c1.506-1.393 2.373-3.446 2.373-5.88Z" />
        <path d="M8.171 16c2.16 0 3.967-.72 5.287-1.94l-2.573-2c-.72.48-1.634.774-2.714.774-2.086 0-3.853-1.407-4.486-3.307H1.03v2.06a7.988 7.988 0 0 0 7.14 4.414Z" />
        <path d="M3.683 9.527a4.642 4.642 0 0 1-.253-1.526c0-.534.093-1.047.253-1.527v-2.06H1.03a7.907 7.907 0 0 0 0 7.173l2.653-2.06Z" />
        <path d="M8.171 3.167c1.18 0 2.234.406 3.067 1.2l2.28-2.28C12.138.793 10.33 0 8.17 0a7.988 7.988 0 0 0-7.14 4.413l2.654 2.06c.633-1.9 2.4-3.306 4.486-3.306Z" />
      </g>
      <defs>
        <clipPath id={`RawGoogleIcon_svg__a${toAppend}`}>
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawGoogleIcon);
export default ForwardRef;
